import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import {
  ServiceRequestTag,
  TagType
} from "@shared/models/service-request-details-dto";
import { Pagination } from "@shared/models/pagination";

@Injectable({
  providedIn: "root"
})
export class TagService {
  private tagsUrl = "tags";

  constructor(private http: HttpClient) {}

  getTags(noPagination?: boolean) {
    if (noPagination) {
      return this.http.get<Pagination<ServiceRequestTag[]>>(
        `${environment.apiUrl}${this.tagsUrl}?pagination=false`
      );
    }

    return this.http.get<Pagination<ServiceRequestTag[]>>(
      `${environment.apiUrl}${this.tagsUrl}`
    );
  }

  getFilteredTags(name: string = "", tagType?: "PUBLIC" | "INTERNAL") {
    let url = `${environment.apiUrl}${this.tagsUrl}/filters?name=${name}`;
    if (tagType) {
      url += `&tagType=${tagType}`;
    }

    return this.http.get<Pagination<ServiceRequestTag[]>>(url);
  }

  getMostUsedTags(tagType: TagType, size: number = 5) {
    return this.http.get<Pagination<ServiceRequestTag[]>>(
      `${environment.apiUrl}${this.tagsUrl}/most-used/${tagType}?size=${size}`
    );
  }
}
